// extracted by mini-css-extract-plugin
module.exports = {"form":"VacancyTemplateForm_form__1IYNW","saveButton":"VacancyTemplateForm_saveButton__308WX"};